import { Breakout } from "../../game";
import { throttle } from "@martinstark/throttle-ts";

const play = (audio: HTMLAudioElement) => {
    audio.play().catch(error => {
        // Let's catch missing interaction errors at this point
        
    });
}


export default {
    error: () => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/error.mp3");
        audio.onended = () => {
            audio.remove();
            audio.srcObject = null;
        }
        play(audio);
        return audio
    },
    waiting: () => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/waiting.mp3");
        audio.loop = true
        play(audio);
        return audio
    },
    success: () => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/success.mp3");
        audio.onended = () => {
            audio.remove();
            audio.srcObject = null;
        }
        play(audio)
        return audio
    },
    complete: () => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/complete.mp3");
        audio.onended = () => {
            audio.remove();
            audio.srcObject = null;
        }
        play(audio)
        return audio
    },
    boot: () => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/boot.mp3");
        play(audio);
        return audio
    },
    music: (autoplay: boolean = true) => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/music.mp3");
        audio.volume = 1
        if (autoplay) play(audio);
        return audio
    },
    breakout: (autoplay: boolean = true) => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/breakout.mp3");
        audio.volume = 1
        if (autoplay) play(audio);
        return audio
    },
    typewrite1: throttle((autoplay: boolean = true) => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/typewrite1.mp3");
        audio.onended = () => {
            audio.remove();
            audio.srcObject = null;
        }
        audio.volume = 0.4
        if (autoplay) play(audio);
        return audio
    }, 50)[0],
    typewrite2: throttle((autoplay: boolean = true) => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/typewrite2.mp3");
        audio.onended = () => {
            audio.remove();
            audio.srcObject = null;
        }
        audio.volume = 0.3
        if (autoplay) play(audio);
        return audio
    }, 50)[0],
    typewrite3: throttle((autoplay: boolean = true) => {
        const audio = new Audio(process.env.PUBLIC_URL + "/sounds/typewrite3.mp3");
        audio.onended = () => {
            audio.remove();
            audio.srcObject = null;
        }
        audio.volume = 0.45
        if (autoplay) play(audio);
        return audio
    }, 50)[0],
    isPlaying: (audio: HTMLAudioElement) => audio.currentTime > 0 && !audio.paused && !audio.ended 
        && audio.readyState > audio.HAVE_CURRENT_DATA
}